// @ts-nocheck

import { Dispatch, SetStateAction, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import Cookies from "js-cookie";

import { CardType, ColumnType } from "./types";
import { Badge } from "@/components/ui/badge/badge";
import { DropIndicator } from "./drop-indicator";
import { Card } from "./card";
import { changeStatusOfTODO } from "@/config/mutation/employee/todo.mutation";

type ColumnProps = {
  title: string;
  headingColor: string;
  cards: CardType[];
  column: ColumnType;
  setCards: Dispatch<SetStateAction<CardType[]>>;
};

export const Column = ({
  title,
  headingColor,
  cards,
  column,
  setCards,
}: ColumnProps) => {
  const [active, setActive] = useState(false);
  const empKey = Cookies.get("key") as string;
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: changeStatusOfTODO(empKey),
  });

  const handleDragStart = (e: DragEvent, card: CardType) => {
    if (e.dataTransfer) {
      e.dataTransfer.setData("cardId", card.id);
    }
  };

  const handleDragEnd = async (e: DragEvent) => {
    if (e.dataTransfer) {
      const cardId = e.dataTransfer.getData("cardId");

      setActive(false);

      clearHighlights();

      const indicators = getIndicators();

      const { element } = getNearestIndicator(e, indicators);

      const before = element.dataset.before || "-1";

      if (before !== cardId) {
        let copy = [...cards];

        const oldCard = copy.find((c) => c.id === cardId);

        if (!oldCard) return;

        let cardToTransfer = { ...oldCard, column };

        copy = copy.filter((c) => c.id !== cardId);

        const moveToBack = before === "-1";

        if (oldCard.column === cardToTransfer.column) {
          console.log("No Mutation");

          if (moveToBack) {
            console.log("In If");
            copy.push(cardToTransfer);
          } else {
            console.log("In Else");
            const insertAtIndex = copy.findIndex((el) => el.id === before);

            if (insertAtIndex === undefined) return;

            copy.splice(insertAtIndex, 0, cardToTransfer);
          }

          setCards(copy);
        } else {
          console.log("Having mutation");
          await mutateAsync(
            {
              status: cardToTransfer?.column,
              todoId: cardToTransfer?.id,
            },
            {
              onSuccess: () => {
                if (moveToBack) {
                  console.log("In If");
                  copy.push(cardToTransfer);
                } else {
                  console.log("In Else");
                  const insertAtIndex = copy.findIndex(
                    (el) => el.id === before
                  );

                  if (insertAtIndex === undefined) return;

                  copy.splice(insertAtIndex, 0, cardToTransfer);
                }
                queryClient.invalidateQueries({
                  queryKey: ["employee-todos"],
                });
                queryClient.invalidateQueries({
                  queryKey: ["employee-todo-status", cardToTransfer?.id],
                });

                toast.success("Todo Status Updated!");

                setCards(copy);
              },
            }
          );
        }
      }
    }
  };

  const handleDragOver = (e: DragEvent) => {
    e.preventDefault();

    highlightIndicator(e);

    setActive(true);
  };

  const clearHighlights = (els?: HTMLElement[]) => {
    const indicators = els || getIndicators();

    indicators.forEach((i) => {
      i.style.opacity = "0";
    });
  };

  const highlightIndicator = (e: DragEvent) => {
    const indicators = getIndicators();

    clearHighlights(indicators);

    const el = getNearestIndicator(e, indicators);

    el.element.style.opacity = "1";
  };

  const getNearestIndicator = (e: DragEvent, indicators: HTMLElement[]) => {
    const DISTANCE_OFFSET = 50;

    const el = indicators.reduce(
      (closest, child) => {
        const box = child.getBoundingClientRect();

        const offset = e.clientY - (box.top + DISTANCE_OFFSET);

        if (offset < 0 && offset > closest.offset) {
          return { offset: offset, element: child };
        } else {
          return closest;
        }
      },

      {
        offset: Number.NEGATIVE_INFINITY,

        element: indicators[indicators.length - 1],
      }
    );

    return el;
  };

  const getIndicators = () => {
    return Array.from(
      document.querySelectorAll(
        `[data-column="${column}"]`
      ) as unknown as HTMLElement[]
    );
  };

  const handleDragLeave = () => {
    clearHighlights();

    setActive(false);
  };

  const filteredCards = cards.filter((c) => c.column === column);

  return (
    <div className="w-64 shrink-0">
      <div className="mb-3 flex items-center justify-between border-b pb-2">
        <h3 className={`font-medium ${headingColor}`}>{title}</h3>

        <Badge className="font-normal" variant="outline">
          {filteredCards.length}
        </Badge>
      </div>

      <div
        onDrop={handleDragEnd}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        className={`h-full w-full transition-colors ${
          active ? "bg-muted/80" : "bg-muted/0"
        }`}
      >
        {filteredCards.map((c) => {
          return (
            <Card key={c.id} cardInfo={c} handleDragStart={handleDragStart} />
          );
        })}

        <DropIndicator beforeId={null} column={column} />

        {/* <AddCard column={column} setCards={setCards} /> */}
      </div>
    </div>
  );
};
